<section class="key-features website-container">
  <h2 class="kf-heading">{{ 'WEBSITE.KEY_FEATURES.TITLE' | translate }}</h2>
  <p class="kf-description page-description">{{ 'WEBSITE.KEY_FEATURES.DESCRIPTION' | translate }}</p>

  <div class="carousel-navigation">
    <button
      class="navigation-button"
      [class.active]="activeSlideIndex === 0"
      (click)="goToSlide(0)">
      {{ 'WEBSITE.KEY_FEATURES.PAGES.FIRST' | translate }}
    </button>

    <button
      class="navigation-button"
      [class.active]="activeSlideIndex === 1"
      (click)="goToSlide(1)">
      {{ 'WEBSITE.KEY_FEATURES.PAGES.SECOND' | translate }}
    </button>

    <button
      class="navigation-button"
      [class.active]="activeSlideIndex === 2"
      (click)="goToSlide(2)">
      {{ 'WEBSITE.KEY_FEATURES.PAGES.THIRD' | translate }}
    </button>

    <button
      class="navigation-button"
      [class.active]="activeSlideIndex === 3"
      (click)="goToSlide(3)">
      {{ 'WEBSITE.KEY_FEATURES.PAGES.FOURTH' | translate }}
    </button>
  </div>

  <div class="features-carousel swiper">
    <div class="carousel-inner-wrapper swiper-wrapper">
      @for (animation of animations; track $index) {
        <div class="swiper-slide">
          @if (animation) {
            <ng-lottie
              width="100%"
              [options]="animation"
            ></ng-lottie>
          }
        </div>
      }
    </div>
  </div>
</section>
